module.exports = __webpack_public_path__ + "static/background-solutions-f59e2187a31e444527b89c8b01a698c4.png";